import { useCallback, useRef, useState } from 'react';
import { isFocusVisible, useFocus, useFocusVisibleListener, useFocusWithin } from '../interactions';
/**
 * Determines whether a focus ring should be shown to indicate keyboard focus.
 * Focus rings are visible only when the user is interacting with a keyboard,
 * not with a mouse, touch, or other input methods.
 */ export function useFocusRing(props = {}) {
    const { autoFocus = false, isTextInput, within } = props;
    const state = useRef({
        isFocused: false,
        isFocusVisible: autoFocus || isFocusVisible()
    });
    const [isFocused, setFocused] = useState(false);
    const [isFocusVisibleState, setFocusVisible] = useState(()=>state.current.isFocused && state.current.isFocusVisible);
    const updateState = useCallback(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    const onFocusChange = useCallback(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (isFocused)=>{
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    useFocusVisibleListener((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput
    });
    const { focusProps } = useFocus({
        isDisabled: within,
        onFocusChange
    });
    const { focusWithinProps } = useFocusWithin({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}

//# sourceMappingURL=useFocusRing.js.map